// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import theme from '../../styled-components/dark';
import BurgerMenuItem from '../NavigationBurgerMenuItem';
import type { Props as Item } from '../NavigationBurgerMenuItem';

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: ${theme.BurgerMenu.backgroundColor};
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
`;

type Props = {
  className?: string;
  items: Array<Item>;
};

const NavigationBurgerMenu = ({ className, items }: Props) => (
  <Wrapper className={className}>
    {items.map(({ label, onClick, icon, isLive = false, counter = undefined }) => (
      <BurgerMenuItem key={label} label={label} onClick={onClick} icon={icon} isLive={isLive} counter={counter} />
    ))}
  </Wrapper>
);
export default NavigationBurgerMenu;
